<template>
    <v-container fluid>
        <v-layout fill-height justify-end row wrap>
            <v-flex xs12 sm12 md8 lg8 xl4 @click="pos={x: $event.clientX, y: $event.clientY}" class="ma-3">
                <v-date-picker
                    v-model="selectedDate"
                    :show-current="date"
                    :events="dates"
                    full-width
                    :landscape="!$vuetify.breakpoint.mdOnly && !$vuetify.breakpoint.xsOnly"
                    reactive
                    color="red"
                    ></v-date-picker>
                <v-menu
                    :value="pronosAtDate.length > 0"
                    @input="selectedDate = null"
                    :position-x="pos.x"
                    :position-y="pos.y"
                    absolute
                    offset-y
                    >
                    <v-list>
                        <v-list-tile
                            v-for="prono in pronosAtDate"
                            :key="prono.id"
                            >
                            <Profile :profile="users[prono.id]" />
                        </v-list-tile>
                    </v-list>
                </v-menu> 
            </v-flex>
            <v-flex xs12 sm5 md8 lg4 xl4 class="ma-3">
                <v-card class="rounded">
                    <v-card-text>
                        <GenderChart
                            :chartData="genderData" />
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 sm5 md8 lg4 xl4 class="ma-3">
                <v-card class="rounded">
                    <v-card-text>
                        <BodyChart
                            :chartData="bodyData" />
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Calendar from "@/components/graphs/Calendar";
import GenderChart from "@/components/graphs/Gender";
import BodyChart from "@/components/graphs/Body";

export default {
  props: {
    baby: Object,
    pronos: Array
  },
  data() {
    return {
      selectedDate: null,
      pos: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    date() {
      if (this.baby) {
        return this.convertDate(this.baby.date);
      } else {
        return null;
      }
    },
    dates() {
      return this.pronos.map(prono => this.convertDate(prono.date));
    },
    pronosAtDate() {
      return this.pronos.filter(
        prono => this.convertDate(prono.date) === this.selectedDate
      );
    },
    genderData() {
      return {
        datasets: [
          {
            data: [
              this.pronos.filter(prono => prono.gender === "Boy").length,
              this.pronos.filter(prono => prono.gender === "Girl").length
            ],
            label: "Gender",
            backgroundColor: ["Teal", "Pink"],
            hoverBackgroundColor: "Red"
          }
        ],
        labels: ["Boy", "Girl"]
      };
    },
    bodyData() {
      return {
        datasets: [
          {
            data: this.pronos.map(prono => ({
              x: prono.weight / 1000,
              y: prono.height
            })),
            label: "height (cm) / weight (kg)",
            backgroundColor: "Red",
            hoverBackgroundColor: "Red",
            radius: 10,
            pointBackgroundColor: "Red",
            pointHoverBackgroundColor: "Red",
            pointHoverRadius: 10
          }
        ]
      };
    }
  },
  methods: {
    convertDate(date) {
      return new Date(date.seconds * 1000).toISOString().split("T")[0];
    }
  },
  components: {
    Calendar,
    GenderChart,
    BodyChart
  }
};
</script>

<style>
.rounded {
  border-radius: 20px;
}
</style>
